import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  Divider,
  IconButton,
  Avatar,
  Box,
  Chip
} from '@mui/material';
import { Close } from '@mui/icons-material';
import './css/Employee.css';

function ViewEmployeeModal({ open, onClose, employee }) {
  // Format dates for display
  const formatDate = (dateString) => {
    if (!dateString) return 'Not specified';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className="employee-modal"
    >
      <DialogTitle className="modal-title">
        Employee Details
        <IconButton onClick={onClose} className="close-button">
          <Close />
        </IconButton>
      </DialogTitle>
      
      <DialogContent dividers className="view-employee-content">
        <Grid container spacing={3}>
          {/* Header with profile */}
          <Grid item xs={12} className="employee-header-section">
            <Box display="flex" alignItems="center">
              <Avatar 
                src={employee.profile} 
                alt={employee.firstName}
                sx={{ width: 80, height: 80 }}
                className="employee-avatar"
              >
                {employee.firstName?.charAt(0)}{employee.lastName?.charAt(0)}
              </Avatar>
              <Box ml={2}>
                <Typography variant="h5">
                  {employee.firstName} {employee.lastName}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  {employee.Designation}
                </Typography>
                <Chip 
                  label={employee.Status ? "Active" : "Inactive"} 
                  color={employee.Status ? "success" : "error"}
                  size="small"
                  className="status-chip"
                />
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12}>
            <Divider />
          </Grid>
          
          {/* Personal Information */}
          <Grid item xs={12}>
            <Typography variant="h6" className="section-title">
              Personal Information
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle2" color="textSecondary">
              Gender
            </Typography>
            <Typography variant="body1">
              {employee.gender || 'Not specified'}
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle2" color="textSecondary">
              Date of Birth
            </Typography>
            <Typography variant="body1">
              {employee.DOB ? formatDate(employee.DOB) : 'Not specified'}
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle2" color="textSecondary">
              Mobile Number
            </Typography>
            <Typography variant="body1">
              {employee.mobile_no || 'Not specified'}
            </Typography>
          </Grid>
          
          {/* Contact Information */}
          <Grid item xs={12}>
            <Typography variant="h6" className="section-title">
              Contact Information
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Company Email
            </Typography>
            <Typography variant="body1">
              {employee.company_email || 'Not specified'}
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Personal Email
            </Typography>
            <Typography variant="body1">
              {employee.personal_email || 'Not specified'}
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Permanent Address
            </Typography>
            <Typography variant="body1">
              {employee.Permanent_Address || 'Not specified'}
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Present Address
            </Typography>
            <Typography variant="body1">
              {employee.Present_Address || 'Not specified'}
            </Typography>
          </Grid>
          
          {/* Employment Information */}
          <Grid item xs={12}>
            <Typography variant="h6" className="section-title">
              Employment Information
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle2" color="textSecondary">
              Employee Code
            </Typography>
            <Typography variant="body1">
              {employee.Employee_code || 'Not specified'}
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle2" color="textSecondary">
              Designation
            </Typography>
            <Typography variant="body1">
              {employee.Designation || 'Not specified'}
            </Typography>
          </Grid>
          
          {/* <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle2" color="textSecondary">
              Employment Type
            </Typography>
            <Typography variant="body1">
              {employee.Employment_type || 'Not specified'}
            </Typography>
          </Grid> */}
          
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle2" color="textSecondary">
              Date of Joining
            </Typography>
            <Typography variant="body1">
              {employee.date_of_Joining ? formatDate(employee.date_of_Joining) : 'Not specified'}
            </Typography>
          </Grid>
          
          {/* <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Role
            </Typography>
            <Typography variant="body1">
              {employee.Role || 'Not specified'}
            </Typography>
          </Grid> */}
          
          {/* System Information */}
          {/* <Grid item xs={12}>
            <Typography variant="h6" className="section-title">
              System Information
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Created At
            </Typography>
            <Typography variant="body1">
              {formatDate(employee.createdAt)}
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Last Updated
            </Typography>
            <Typography variant="body1">
              {formatDate(employee.updatedAt)}
            </Typography>
          </Grid> */}
        </Grid>
      </DialogContent>
      
      <DialogActions className="modal-actions">
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ViewEmployeeModal;
